import { Company } from '../companyDetail'
import { SearchCompany } from '../search'

export enum OrderType {
  Normal = 'Normal',
  BuyNow = 'BuyNow'
}

export enum OrderStatus {
  Draft = 'Draft',
  Confirmed = 'Confirmed',
  Paid = 'Paid',
  Placed = 'Placed',
  Completed = 'Completed',
  CompletedWithSuccess = 'CompletedWithSuccess',
  CompletedWithProcessingError = 'CompletedWithProcessingError',
  CompletedWithPartialError = 'CompletedWithPartialError',
  CompletedWithDeliveryErrors = 'CompletedWithDeliveryErrors'
}

export enum PaymentStatus {
  Created = 'Created',
  Approved = 'Approved',
  Authorized = 'Authorized',
  Captured = 'Captured',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}

export enum PaymentMethod {
  None = 'None',
  Card = 'Card',
  Paypal = 'Paypal',
  Alipay = 'Alipay',
  Prepaid = 'Prepaid'
}

export enum OrderItemStatusCode {
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  Error = 'Error'
}

export type OrderData = {
  orderId: string
  placedAt?: Date
  paymentMethod?: PaymentMethod
  orderType: OrderType
  orderStatus: OrderStatus
  paymentStatus?: PaymentStatus
  totalTaxValueFormatted: string
  totalNetValueFormatted: string
  totalValueWithTaxFormatted: string
  currency: string
  isAccountingError: boolean
  totalValueWithTax: number
  isAnyCustomerRequestError?: boolean
}

export type OrderState = {
  orderMetadata?: OrderMetadata
  orderData?: OrderData
  orderItems: OrderItem[]
  orderError?: any
}

export type OrderItem = {
  customerRequestId: string
  orderId: string
  companyId?: string
  companyName: string
  countryCode: string
  deliveryOptionCode?: string
  languageCode?: string
  reportType: string
  netValueFormatted: string
  errorCode: string
  statusCode: OrderItemStatusCode
  companyIdentifier?: string
  lastUpdateDate?: string
  documentDate?: string
  valueWithTaxFormatted: string
  valueWithTax: number
  reportName: string
  identifierType: string
  identifier: string
}

export type RegistrationNumber = {
  code: string
  value: string
}

export type AddToCartRequestBody = {
  orderId?: string
  customerRequests: {
    entityIdentifierEncoded?: string
    entityName?: string
    countryCode: string
    lastUpdateDate?: string
    deliveryOptionCode?: string
    productCode: string
    languageCode: string
    documentDate?: string
    versionId?: string
    investigationData?: {
      companyName: string
      countryCode?: string
      stateCode?: string
      townCode?: string
      townName?: string
      postalCode?: string
      addressLine: string
      registrationNumbers: RegistrationNumber[]
      companyContact?: string
      email?: string
      phone?: string
      note?: string
      customerReference?: string
    }
    consentProvided?: boolean
    materialTypePriceParam?: string
    countryCodePriceParam?: string
    isFinancialPriceParam?: string
    inRevisionPriceParam?: string
    dataTypePriceParam?: string
    providerName?: string
    providerCode?: string
    proofOfInterest?: string
  }[]
}

export type AddItemToCartResponse = {
  data: {
    orderId: string
    orderType?: string
    orderStatus?: string
  }
}

export type AddItemToCartGtmData = {
  currency: string | undefined
  value: number | undefined
  price: number | undefined
  reportName: string | undefined
  company: Company | SearchCompany | undefined
  cartItemsCount: number
  button: number
}

export type OrderMetadata = {
  id?: string
  itemCount?: number
}
